// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recap-first-left{
  width: 400px;
  height: 200px;
  position: relative;
  border-radius: 15px;
}

.recap-first-left-absolute{
  position: absolute;
  top: 0;
  left: 0;    
  border-radius: 15px;
  width: -webkit-fill-available;
  height: -webkit-fill-available;
  background: linear-gradient(7deg, var(--primary) 21.68%, rgba(43, 100, 245, 0.00) 91.47%);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  padding: 20px;
  color: white;
  font-weight: bold;
}

.no-padding{
  padding: 0px;
  margin: 0px;
}

.additional-infos{
  color: var(--primary);
}

.recap-first{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  width: -webkit-fill-available;
  padding: 20px;
}

.recap-first-right{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 7px;
  width: 50%;
  padding: 20px;
}

.product-title{
  font-size: 20px;
  font-weight: bold;
}

.recap-first-grid{
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  width: -webkit-fill-available;
}

.recap-first-grid-item{
  background-color: var(--bg-card);
  border-radius: 7px;
  padding: 10px;
}

.recap-first-grid-title{
  font-size: 15px;
  font-weight: bold;
}

.recap-first-grid-data{
  font-size: 22px;
  margin-left: auto;
  margin-right: 0px;
  text-align: right;
  font-weight: bold;
}

.recap-small-text{
  font-size: 12px;
  color: var(--text-muted);
}

.recap-indices{
  background-color: var(--bg-card);
  width: 50%;
  padding: 15px;
  border-radius: 12px;
}

.recap-user-box{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
}

.recap-user-pic{
  width: 35px;
  height: 35px;
  border-radius: 50%;
}

.recap-user-name{
  font-size: 16px;
  font-weight: bold;
}

.recap-desc-title{
  font-size: 16px;
  font-weight: bold;
}

.recap-desc-message{
  font-size: 14px;
}

.recap-text-box{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 20px;
  margin-top: 20px;
  padding: 0px 20px 0px 20px;
  width: -webkit-fill-available;
}

.recap-desc-box{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
}

.recap-desc-item{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/pages/structured/builder/recap/recap.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,mBAAmB;EACnB,6BAA6B;EAC7B,8BAA8B;EAC9B,yFAAyF;EACzF,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,QAAQ;EACR,UAAU;EACV,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,SAAS;AACX","sourcesContent":[".recap-first-left{\n  width: 400px;\n  height: 200px;\n  position: relative;\n  border-radius: 15px;\n}\n\n.recap-first-left-absolute{\n  position: absolute;\n  top: 0;\n  left: 0;    \n  border-radius: 15px;\n  width: -webkit-fill-available;\n  height: -webkit-fill-available;\n  background: linear-gradient(7deg, var(--primary) 21.68%, rgba(43, 100, 245, 0.00) 91.47%);\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-end;\n  padding: 20px;\n  color: white;\n  font-weight: bold;\n}\n\n.no-padding{\n  padding: 0px;\n  margin: 0px;\n}\n\n.additional-infos{\n  color: var(--primary);\n}\n\n.recap-first{\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n  width: -webkit-fill-available;\n  padding: 20px;\n}\n\n.recap-first-right{\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 7px;\n  width: 50%;\n  padding: 20px;\n}\n\n.product-title{\n  font-size: 20px;\n  font-weight: bold;\n}\n\n.recap-first-grid{\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  width: -webkit-fill-available;\n}\n\n.recap-first-grid-item{\n  background-color: var(--bg-card);\n  border-radius: 7px;\n  padding: 10px;\n}\n\n.recap-first-grid-title{\n  font-size: 15px;\n  font-weight: bold;\n}\n\n.recap-first-grid-data{\n  font-size: 22px;\n  margin-left: auto;\n  margin-right: 0px;\n  text-align: right;\n  font-weight: bold;\n}\n\n.recap-small-text{\n  font-size: 12px;\n  color: var(--text-muted);\n}\n\n.recap-indices{\n  background-color: var(--bg-card);\n  width: 50%;\n  padding: 15px;\n  border-radius: 12px;\n}\n\n.recap-user-box{\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 10px;\n}\n\n.recap-user-pic{\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n}\n\n.recap-user-name{\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.recap-desc-title{\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.recap-desc-message{\n  font-size: 14px;\n}\n\n.recap-text-box{\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 20px;\n  margin-top: 20px;\n  padding: 0px 20px 0px 20px;\n  width: -webkit-fill-available;\n}\n\n.recap-desc-box{\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.recap-desc-item{\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
